import type { IconData } from '@stacksjs/iconify-core'

export const airplaneMode: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m476.757 337.8l13.329-66.646L320 186.111v-72.222a105.15 105.15 0 0 0-37.937-81a40.705 40.705 0 0 0-52.126 0a105.15 105.15 0 0 0-37.937 81v72.222L21.914 271.154L35.243 337.8l157.189-20.5l7.736 81.224L128 429.45V496h256v-66.55l-72.168-30.929l7.736-81.224ZM352 450.551V464H160v-13.449l74.238-31.818L224 311.24v-30.332L60.757 302.2l-2.671-13.354L224 205.889v-92a73.24 73.24 0 0 1 26.423-56.413a8.71 8.71 0 0 1 11.154 0A73.24 73.24 0 0 1 288 113.889v92l165.914 82.957l-2.671 13.354L288 280.908v30.332l-10.238 107.493Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default airplaneMode
